<template>
	<!-- <el-dialog :visible.sync="showqgaccount" :title="dialogtitle" width="500px" :append-to-body="true"  :close-on-click-modal="false"> -->
	<div class="qgaccount" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-row style="margin-top:5%;">
			<el-col :span="7" style="color:transparent">1</el-col>
			<el-col :span="8">
				<el-form size="mini" label-width="130px">
					<el-form-item :label="qgaccount_lang.location">
						<el-select v-model="qgaccount.location" style="width:100%">
							<el-option v-for="item in locationlist"  :key="item.label"  :label="item.label" :value="item.label"></el-option>
						</el-select>
					</el-form-item> 
					<el-form-item :label="qgaccount_lang.sendername">
						<el-input v-model="qgaccount.sendername"></el-input>
					</el-form-item>
					<el-form-item :label="qgaccount_lang.clientid">
						<el-input v-model="qgaccount.clientid"></el-input>
					</el-form-item>
					<el-form-item :label="qgaccount_lang.senderid">
						<el-input v-model="qgaccount.senderid"></el-input>
					</el-form-item>
					<el-form-item :label="qgaccount_lang.key">
						<el-input v-model="qgaccount.key"></el-input>
					</el-form-item>
					<el-form-item :label="qgaccount_lang.privatekey">
						<el-upload
							name="fileupload"
							:action="fileurl"
							:multiple="false"
							:limit="1"
							accept=".key"
							:on-success="UploadSuccess"
							:on-error="UploadError"
							:on-change="UploadChange"
							:auto-upload="false"
							:show-file-list="false"
							ref="upload"
							:file-list="filelist"
							:before-upload="UploadBefore"
						>
						<el-button size="mini" type="primary">{{$lang.label.public.btnupload}}</el-button>
						</el-upload>
						<span>{{ filename }}</span>
					</el-form-item>				
				</el-form>
			</el-col>
		</el-row>		
		<el-row style="margin-top:20px">
			<el-col :span="10" style="color:transparent">1</el-col>
			<el-col :span="8">
				<div>
					<el-button type="success" @click.native="saveqgaccount">{{$lang.label.public.savebtn}}</el-button>
					<el-button style="margin-left:10px" type="info" plain @click.native="cancel">{{$lang.label.public.cancel}}</el-button>
				</div>
			</el-col>
		</el-row>
	</div>
	<!-- </el-dialog> -->
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
	},
	data() {
		return {
			//showqgaccount:false,
			qgaccount_lang:{},
			qgaccount:{
				location:'',
				sendername:'',
				clientid:'',
				senderid:'',
				key:'',
				privatekey:''
			},
			id:'',
			fileurl:'',
			filelist:[],
			filename:'',
			dialogtitle:'',
			locationlist:[],
			windowHeight: window.innerHeight - 120,
			divclass:'qgaccount',
			l_id:''
		}
	},
	created() {
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/baseinfo/qgaccount.scss');
		this.init();
	},
	methods: {
		init() {
			debugger
			if(this.item.row!=undefined)
			{
				if(this.item.row.id!=undefined){
					this.id=this.item.row.id;
				}
			}
			this.loadlanguage();
			this.fileurl=this.$apiprototype.ApiServer +'/Base/submitqgkey?domain='+this.$apiprototype.WebServer+'&sendername='+this.qgaccount.sendername;
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('qgaccount',this).then(res=>{
				if(res.state=='1')
					that.qgaccount_lang=that.$lang.label.qgaccount;
				that.dialogtitle=that.qgaccount_lang.title;
				that.loadlocation();
			});
		},
		getInfo(){
			var that=this;
			if(this.id!=''){
				this.$tool.loading(that.$lang.label.public.loading, this.divclass);
				var paraminfo={
					pkval:this.id,
					l_id:this.l_id
				}
				this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						that.qgaccount = res.info;
					} else
						this.$tool.message(that.$lang.label.public.getinfofailed, "0");
				});
			}
		},
		loadlocation(){
			var that=this;
			this.$apipost.get.dic({type:'申报地'}).then(res=>{
				if(res.list!=undefined){
					that.locationlist=res.list;
				}
				that.getInfo();
			});
		},
		UploadSuccess(res, file, fileList) {
			if (res.state == '1') {
				this.qgaccount.privatekey = res.path;
				this.saveqgaccount2();
			} else {
				this.$tool.loadingclose();
				this.filename = '';
				this.$tool.message(res.message, 0);
			}
			this.$refs.upload.clearFiles();
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			this.fileurl=this.$apiprototype.ApiServer +'/Base/submitqgkey?domain='+this.$apiprototype.WebServer+'&sendername='+this.qgaccount.sendername;
			if(fileList.length>0)
				this.filename=file.name;
		},
		UploadBefore(file){
			
		},
		saveqgaccount(){
			var that=this;
			if(this.qgaccount.location.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.qgaccount_lang.location, 0);
				return false;
			}
			if(this.qgaccount.sendername.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.qgaccount_lang.sendername, 0);
				return false;
			}
			if(this.qgaccount.clientid.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.qgaccount_lang.clientid, 0);
				return false;
			}
			if(this.qgaccount.senderid.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.qgaccount_lang.senderid, 0);
				return false;
			}
			if(this.qgaccount.key.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.qgaccount_lang.key, 0);
				return false;
			}
			if(this.filename==''&&this.qgaccount.privatekey=='')
			{
				this.$tool.message(this.$lang.label.public.pleaseupload+this.qgaccount_lang.privatekey, 0);
				return false;
			}
			//debugger
			this.$tool.loading(this.$lang.label.public.saving, this.divclass);
			if(this.filelist.length==0)
				this.saveqgaccount2();
			else
				this.$refs.upload.submit();
		},
		saveqgaccount2(){
			var paraminfo={
				id:this.id,
				qgaccount:this.qgaccount,
				u_userid:localStorage.getItem('userid'),
				u_account:localStorage.getItem('u_account'),
				u_name:localStorage.getItem('u_name'),
				handleaccount:localStorage.getItem('u_account')
			}
			var that=this;
			this.$apipost.post.saveqgaccount({paraminfo:paraminfo}).then(res=>{
				if(res.state=='1'){
					this.$tool.message(that.$lang.label.public.savesuccess, 1);
					setTimeout(function(){
						that.cancel();
					},500);
				}else if(res.state=='2'){
					this.$tool.message(that.qgaccount.sendername+that.$lang.label.public.exists, 0);
				}else
					this.$tool.message(that.$lang.label.public.savefail, 0);
			});
		},
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
}
</script>

<style>
</style>